import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

export default function ProductButton({icon, modifier, subtitle, title, ...buttonProps}) {
  const componentClasses = classNames('c-product-button', {
    [`c-product-button--${modifier}`]: modifier,
  })
  const mediaClasses = classNames('o-media', {'o-media--centered': !subtitle})

  return (
    <button className={componentClasses} type="button" {...buttonProps}>
      <span className={mediaClasses}>
        {icon && (
          <i
            className="o-media__figure c-product-button__icon"
            style={{backgroundImage: `url(${icon})`}}
          />
        )}
        <span className="o-media__body">
          <span className="c-product-button__title">{title}</span>
          {subtitle && <span className="c-product-button__subtitle">{subtitle}</span>}
        </span>
      </span>
    </button>
  )
}

ProductButton.propTypes = {
  icon: PropTypes.string,
  modifier: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
}
